import { render, staticRenderFns } from "./ProductPreviewNewView.vue?vue&type=template&id=40096342&scoped=true"
import script from "./ProductPreviewNewView.vue?vue&type=script&lang=js"
export * from "./ProductPreviewNewView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40096342",
  null
  
)

export default component.exports